var render = function render(){var _vm=this,_c=_vm._self._c;return _c('custom-btn-icon',{attrs:{"small":"","isText":_vm.isText,"href":_vm.href,"target":"_blank","btn-text":"P2O","icon":"mdi-progress-clock","color":_vm.color},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }